/**
 * @param event TouchEndEvent
 */
export var isTap = function (event) {
    if (event.touches.length < 2 && event.changedTouches.length < 2) {
        var touch = event.touches[0] || event.changedTouches[0];
        var elm = document.elementFromPoint(touch.clientX, touch.clientY);
        return event.currentTarget === elm || event.currentTarget.contains(elm);
    }
    return false;
};
